import React, { Component } from 'react';
import DataTables from './DataTables';
import Cookie from 'js-cookie';
import { Config } from '../config/config';
import { Navigate } from 'react-router-dom';
import Menu from './Menu';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';
import Multi from './MultiCityStores';
import MultiCities from './MultiCities';
import MultiMonths from './MultiMonths';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import Spinner from '../UIComponents/Spinner/Spinner';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import { Helmet } from 'react-helmet';
import { Tooltip as ReactTooltip} from 'react-tooltip';
import { Link } from 'react-router-dom';
import DataPopUp from './CityLeader/DataPopUp';
import LZString from 'lz-string';
import {
  CityDasboardLegend,
  PopUpData,
  PopUpData1,
} from './CityLeader/CityDasboardLegends';

console.disableYellowBox = true;

class Cityleader extends Component {
  constructor(props) {
    super(props);

    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    const menu = user['moduleAccess'];
    const config = JSON.parse(Config);
    let userID = user['userId'];
    localStorage.removeItem('curStoreID');
    localStorage.removeItem('tabName');
    localStorage.removeItem('warehouse_tabName');
    let month = [
      { label: 'January', value: 1 },
      { label: 'February', value: 2 },
      { label: 'March ', value: 3 },
      { label: 'April ', value: 4 },
      { label: 'May ', value: 5 },
      { label: 'June ', value: 6 },
      { label: 'July ', value: 7 },
      { label: 'August ', value: 8 },
      { label: 'September ', value: 9 },
      { label: 'October ', value: 10 },
      { label: 'November ', value: 11 },
      { label: 'December ', value: 12 },
    ];

    month.map((val) => {
      val.currentMonth = 0;
      if (val.value === new Date().getMonth() + 1) {
        val.currentMonth = 1;
      }
    });

    let cities = JSON.parse(localStorage.getItem('CitiesForWarehouse'));
    let cname = '';

    cities.cityInfos.map((val) => {
      val.activeCity = 0;

      if (val.cityId == localStorage.getItem('currentCityForCityDashboard')) {
        val.activeCity = 1;
        cname = val.cityName;
      }
    });

    let x = [];
    x.push(cname);

    this.state = {
      title: 'City Leader Dashboard',

      proxyJsonWeeklyCheckList: [],

      userID,

      apiInterface: config['api'],
      proxyjson: [],
      proxyjson1: [],

      proxyjson4: [],
      proxyjson5: [],
      navigate1: false,
      loading: false,
      month,
      user: menu,
      pageAllowed: false,

      currentMonth: new Date().getMonth() + 1,
      currentyear: new Date().getFullYear(),
      years: config['years'],
      cities,
      currentCity: localStorage.getItem('currentCityForCityDashboard')
        ? localStorage.getItem('currentCityForCityDashboard')
        : '',
      cityChanged: false,
      multiSearch: '',
      activeTab: '',
      storSearch: [],
      searchValue: false,
      pageLoad: false,
      storeCityEnabled: false,
      warehouseCityEnabled: false,
      modalOpenGrid: false,
      pUType: '',
      stores: [],
      message: [],
      storeIdNo: this.props.location.state ? this.props.location.state.cid : '',
      cityIDS: this.props.location.state
        ? this.props.location.state.cityid
        : '',
      noOfStores: null,
      storeName: '',
      warehouses: [],
      cityNM: x,
      cname,
      storesData: [],
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(
    index,
    userID = this.state.userID,
    month = this.state.currentMonth,
    year = this.state.currentyear
  ) {
    localStorage.setItem('multi_store_tabName', index);

    this.setState({
      activeTab: index,
      loading: true,
    });

    let ma = [];

    if (month.length > 1) {
      ma = month.split(',');
    }

    if (index > 1) {
      ApiGateWay.Post(this.state.apiInterface + '/fetchCityDashboardRetail', {
        userId: userID,
        month: month,
        year: year,
      })
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            alert('Your session has expired. Please login again.');
            return (window.location = '/');
          }
          this.setState({
            proxyjson1: response.storeGlobalDashBoardRetail,
          });
          console.log(JSON.stringify(response));
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
      ApiGateWay.Post(
        this.state.apiInterface + '/fetchTrainingGlobalDashboardRetail',
        {
          userId: userID,
          month: month.length > 1 ? ma.slice(-1)[0] : month,
          year: year,
        }
      )
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            alert('Your session has expired. Please login again.');
            return (window.location = '/');
          }

          let body = [];
          let colorCodes = [];
          let proxyjson = [];
          let stores = [];
          let storeID = [];
          let obj;
          // alert(JSON.stringify(response));
          response.ratailDashboardInfo.map((name, val) => {
            storeID.push(name.storeId);
            stores.push(name.storeName);

            if (val == 0) {
              obj = name;
            }

            let color = [];
            name.storeStatus.toString() == 'Low'
              ? color.push(1)
              : name.storeStatus.toString() == 'High'
              ? color.push(2)
              : color.push(12);
            name.inductionValue == 100
              ? color.push(1)
              : name.inductionValue < 95
              ? color.push(2)
              : color.push(12);
            name.fatFrtValue >= 80
              ? color.push(1)
              : name.fatFrtValue < 70
              ? color.push(2)
              : color.push(12);

            name.dmTrainingPercentage.toString() ==
            obj.dmTrainingPercentage.toString()
              ? color.push(1)
              : color.push(0);
            name.validationValue == '100'
              ? color.push(1)
              : name.validationValue < '90'
              ? color.push(2)
              : color.push(12);
            name.dmRevalidationPercentage.toString() == '100%'
              ? color.push(0)
              : name.dmRevalidationPercentage.toString() < '90%'
              ? color.push(0)
              : color.push(0);
            name.flowsValue >= 80
              ? color.push(1)
              : name.flowsValue < 70
              ? color.push(2)
              : color.push(12);
            name.somPercentage.toString() == obj.somPercentage.toString()
              ? color.push(1)
              : color.push(0);

            if (val == 0) {
              colorCodes.push([0, 0, 0, 0, 0, 0, 0, 0, 0]);
            } else colorCodes.push(color);

            body.push([
              name.storeStatus,
              name.inductionPercentage,
              name.fatFrtPercentage,

              name.dmTrainingPercentage,
              name.dmValidationPercentage,
              name.dmRevalidationPercentage,
              name.flowsPercentage,
              name.somPercentage,
            ]);
          });
          let GlobalProxyjson = {
            type: 'Training',
            thead: [
              'Store Name',
              'Risk Level',
              'Induction',
              'FAT and FRT',

              'DM Training',
              'DM Validation',
              'DM Revalidation',
              'Flows Training',
              'SOM Training',
            ],
            tbody: body,
            columns: [
              'Store Name',
              'Risk Level',
              'Induction',
              'FAT and FRT',

              'DM Training',
              'DM Validation',
              'DM Revalidation',
              'Flows Training',
              'SOM Training',
            ],
            colorCodes: colorCodes,
            storeId: storeID,
            stores: stores,
          };
          this.setState({
            proxyjson5: GlobalProxyjson,
            loading: false,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later.$',
          });
        });
    } else if (index < 2) {
      ApiGateWay.Post(
        this.state.apiInterface + '/fetchStoreWiseCityDashboardRetail',
        {
          storeId: this.state.storeIdNo,

          year: year,
        }
      )
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            alert('Your session has expired. Please login again.');
            return (window.location = '/');
          }
          this.setState({
            proxyjson1: response.storeWiseGlobalDashBoardRetail,
          });
          console.log(JSON.stringify(response));
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });

      ApiGateWay.Get(
        this.state.apiInterface +
          '/fetchTrainingMonthWiseDashboardRetail?storeId=' +
          this.state.storeIdNo +
          '&year=' +
          year
      )
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            alert('Your session has expired. Please login again.');
            return (window.location = '/');
          }
          let body = [];
          let colorCodes = [];
          let proxyjson = [];
          let stores = [];
          let storeID = [];
          let obj;

          response.ratailInfo.map((name, val) => {
            storeID.push(name.monthId);
            stores.push(name.monthName);

            if (val == 0) {
              obj = name;
            }

            let color = [];
            name.storeStatus.toString() == 'Low'
              ? color.push(1)
              : name.storeStatus.toString() == 'High'
              ? color.push(2)
              : color.push(12);
            name.inductionValue == 100
              ? color.push(1)
              : name.inductionValue < 95
              ? color.push(2)
              : color.push(12);
            name.fatFrtValue >= 80
              ? color.push(1)
              : name.fatFrtValue < 70
              ? color.push(2)
              : color.push(12);

            name.dmTrainingPercentage.toString() ==
            obj.dmTrainingPercentage.toString()
              ? color.push(1)
              : color.push(0);
            name.validationValue.toString() == '100'
              ? color.push(1)
              : name.validationValue.toString() < '90'
              ? color.push(2)
              : color.push(12);
            name.dmRevalidationPercentage.toString() == '100%'
              ? color.push(1)
              : name.dmRevalidationPercentage.toString() < '90%'
              ? color.push(2)
              : color.push(12);
            name.flowsValue >= 80
              ? color.push(1)
              : name.flowsValue < 70
              ? color.push(2)
              : color.push(12);
            name.somPercentage.toString() == obj.somPercentage.toString()
              ? color.push(1)
              : color.push(0);

            if (val == 0) {
              colorCodes.push([0, 0, 0, 0, 0, 0, 0, 0]);
            } else colorCodes.push(color);

            body.push([
              name.storeStatus,
              name.inductionPercentage,
              name.fatFrtPercentage,

              name.dmTrainingPercentage,
              name.dmValidationPercentage,
              name.dmRevalidationPercentage,
              name.flowsPercentage,
              name.somPercentage,
            ]);
          });

          let storeProxyjson = {
            type: 'Training',
            thead: [
              'Month Name',
              'Risk Level',
              'Induction',
              'FAT and FRT',

              'DM Training',
              'DM Validation',
              'DM Revalidation',
              'Flows Training',
              'SOM Training',
            ],
            tbody: body,
            columns: [
              'Month Name',
              'Risk Level',
              'Induction',
              'FAT and FRT',

              'DM Training',
              'DM Validation',
              'DM Revalidation',
              'Flows Training',
              'SOM Training',
            ],
            colorCodes: colorCodes,
            storeId: storeID,
            stores: stores,
          };

          this.setState({
            proxyjson4: storeProxyjson,
          });
          if (storeProxyjson) {
            this.setState({
              loading: false,
            });
          }
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    }
  }

  handleYearChange = (e) => {
    this.setState({
      currentyear: e.target.value,
    });
    this.handleSelect(
      this.state.activeTab,
      this.state.userID,
      this.state.currentMonth,
      e.target.value
    );
  };
  handleClose = () => {
    this.setState({
      modalOpenGrid: false,
      modalOpen: false,
      message: '',
    });
  };
  setLoading = (documentPath) => {
    this.setState({
      pageLoad: true,
    });

    let headers = {
      Authorization: 'Bearer ' + JSON.parse(Cookie.get('token')),
      'Access-Control-Allow-Origin': '*',
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    };
    axios
      .get(
        process.env.REACT_APP_UPLOAD_DOWNLOAD +
          this.state.apiInterface +
          '/download?objectId=' +
          documentPath,
        {
          headers: headers,
          responseType: 'blob',
        }
      )
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }
        var re = /(?:\.([^.]+))?$/;

        var ext = re.exec(documentPath)[1]; // "txt"
        const MimeTypesMap = {
          png: 'image/png',
          gif: 'image/gif',
          jpg: 'image/jpg',
          jpeg: 'image/jpeg',
          pdf: 'application/pdf',
          mp4: 'video/mp4',
          doc: 'application/msword',
          docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          ppt: 'application/vnd.ms-powerpoint',
          pptx: 'application/vnd.ms-powerpoint',
          xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        };

        const mimeType = MimeTypesMap[ext];

        const file = new Blob([response.data], { type: mimeType });
        //Build a URL from the file

        const fileURL = URL.createObjectURL(file);

        //Open the URL on new Window
        if (mimeType === 'application/pdf') {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', documentPath); //or any other extension
          document.body.appendChild(link);
          link.click();
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', documentPath); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
        this.setState({
          pageLoad: false,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          pageLoad: false,

          message: 'Something went wrong please try again after sometime!!',
        });
      });
  };
  handleMonthChange = (x) => {
    //alert(JSON.stringify(x));
    let monthId = x;
    let monnthIds = [];
    monthId &&
      monthId.map((val) => {
        monnthIds.push(val.value);
      });
    this.setState({
      currentMonth: monnthIds.join(),
    });
    this.handleSelect(
      this.state.activeTab,
      this.state.userID,
      //monnthIds.slice(-1)[0],
      monnthIds.join(),
      this.state.currentyear
    );
  };
  handleCityChange = (x) => {
    this.setState({
      loading: false,
    });

    let cityID = x;
    let cityNM = [];
    let cityIDs = [];

    cityID &&
      cityID.map((val) => {
        cityNM.push(val.label);
        return cityIDs.push(val.value);
      });
    this.setState({
      cityNM: cityNM,
      cityIDS: cityIDs.join(),
    });
    localStorage.setItem('currentCityForCityDashboard', cityIDs.slice(-1)[0]);
    ApiGateWay.Post(this.state.apiInterface + `/fetchStoreInfo`, {
      userId: this.state.userID,
      cityIds: cityIDs.join(),
      appType: 'Web',
    })
      .then((response) => response.json())
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }

        if (response['storesInfos'][0]['storeType'] === 'Store') {
          localStorage.setItem(
            'warehouseData1',
            JSON.stringify(response['storesInfos'][1]['storeLocationsInfos'])
          );

          this.setState({
            navigate1: true,
            loading: false,
            stores: response['storesInfos'][0]['storeLocationsInfos'],
          });
        } else {
          localStorage.setItem(
            'warehouseData1',
            JSON.stringify(response['storesInfos'][0]['storeLocationsInfos'])
          );
          this.setState({
            navigate1: true,
            loading: false,
            stores: response['storesInfos'][1]['storeLocationsInfos'],
          });
        }
        
      })
      .catch(() => {
        this.setState({
          modalOpen: !this.state.modalOpen,
          message: 'Something went wrong please try again after sometime',
          loading: false,
        });
      });
  };
  handleSearch = () => {
    this.setState({
      loading: true,
    });

    let storesForMultiSearch = JSON.parse(localStorage.getItem('warehouseData1'));

    let multiSearchData = JSON.parse(localStorage.getItem('multiSearchCities'));
    //  alert(localStorage.getItem('multiSearchCities'));
    let storeData1 = [];

    storesForMultiSearch.map((value) => {
      value.activeFlag = 0;

      JSON.parse(multiSearchData.data).map((val) => {
        if (val.label === value.storeName) {
          value.activeFlag = 1;
          storeData1.push({
            label: value.storeName,
            value: value.storeId,
          });
        }
      });
    });

    let storeIDs = storeData1.map((v) => v.value);
    let storeNames = storeData1.map((v) => v.label);

    this.setState({
      storSearch: storesForMultiSearch,
      noOfStores: storeData1.length,
      storeIdNo: storeIDs.join(),
      storeName: storeNames.join(),
      storesData: storeData1,
    });
    console.log(this.state);
    const jsonData = Cookie.get('currentUser');
          let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
          const user = JSON.parse(decompressedData);
    let userID = user['userId'];
    let data = {
      appType: 'Web',
      storeType: 'Warehouse',
      storeIds: JSON.parse(multiSearchData.data).map((val) => val.value),
      userId: userID,
    };

    ApiGateWay.Post(this.state.apiInterface + '/updateCurrentStore', data)
      .then((response) => response.json())
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }
        if (response) {
          this.setState({
            multiSearch: data,
            cityChanged: false,
          });
        }

        this.handleSelect(parseInt(storeData1.length));
      })
      .catch(() => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });
  };

  handleOnClick = (details, pUType) => {
    this.setState({
      loading: true,
      pUType: pUType,
    });

    let sId = details.storeId;
    let cMonth = this.state.currentMonth;
    let sName = details.storeName;
    if (details.storeId === undefined) {
      sId = this.state.storeIdNo;
      cMonth = details.monthNumber;
      sName = this.state.storeName;
    }

    let type = '';

    if (this.state.activeTab > 1) {
      type = '';
    } else {
      type = 1;
    }
    let ma = [];
    if (this.state.currentMonth.length > 1) {
      ma = this.state.currentMonth.split(',');
    }
    if (cMonth == '13') {
      /* cMonth =
        this.state.currentMonth.length > 1
          ? ma.slice(-1)[0]
          : this.state.currentMonth; */
      cMonth = '1,2,3,4,5,6,7,8,9,10,11,12';
      type = '';
    }
    if (sId === 0) {
      sId = this.state.storeIdNo;
    }
    if (pUType === 'SOD' || pUType === 'Flows' || pUType === 'BSU') {
      ApiGateWay.Get(
        this.state.apiInterface +
          '/fetchStoreWiseCityDashbordHandoverDetails?storeId=' +
          sId +
          '&month=' +
          cMonth +
          '&year=' +
          this.state.currentyear +
          '&checklistType=' +
          pUType
      )
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            alert('Your session has expired. Please login again.');
            return (window.location = '/');
          }
          // alert(JSON.stringify(response));
          let storeProxyjson = [];
          if (pUType === 'BSU') {
            storeProxyjson = {
              type: pUType,
              thead: [
                'Date',
                'Score',
                'Status',
                'Sport Name',
                'Created By',
                'View Document',
              ],
              tbody: response.bsuHandoverInfos,
              storeName: sName,
            };
          } else {
            storeProxyjson = {
              type: pUType,
              thead: ['Date', 'Score', 'Status', 'Created By', 'View Document'],
              tbody: response.monthlyHandoverInfos,
              storeName: sName,
            };
          }

          this.setState({
            modalOpenGrid: !this.state.modalOpenGrid,
            message: storeProxyjson,
            loading: false,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else if (pUType === 'All' || pUType === 'Open') {
      ApiGateWay.Get(
        this.state.apiInterface +
          '/fetchStoreWiseCityDashbordIncidentDetails?storeId=' +
          sId +
          '&month=' +
          cMonth +
          '&year=' +
          this.state.currentyear +
          '&incidentStatus=' +
          pUType +
          '&type=' +
          type
      )
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            alert('Your session has expired. Please login again.');
            return (window.location = '/');
          }
          // alert(JSON.stringify(response));
          let storeProxyjson = {
            type: 'Incidents',
            thead: [
              'Incident Type',
              'Alert Level',
              'Status',
              'Date',
              'Created By',
              'Incident Details',
              'View Document',
            ],
            tbody: response.infos,
            storeName: sName,
          };
          this.setState({
            modalOpenGrid: !this.state.modalOpenGrid,
            message: storeProxyjson,
            loading: false,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else {
      ApiGateWay.Get(
        this.state.apiInterface +
          '/fetchStoreWiseCityDashbordNCDetails?storeId=' +
          sId +
          '&month=' +
          cMonth +
          '&year=' +
          this.state.currentyear +
          '&priority=' +
          pUType +
          '&type=' +
          type
      )
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            alert('Your session has expired. Please login again.');
            return (window.location = '/');
          }
          // alert(JSON.stringify(response));
          let storeProxyjson = {
            type: pUType === '' ? 'Open Non-Confirmities' : 'High Priority',
            thead: [
              'Description',
              'Priority',
              'Due Date',
              'Created Date',
              'Created By',
              'Assigned To',
              'Status',
              'Source',
              'Comments',
            ],
            tbody: response.infos,
            storeName: sName,
          };
          this.setState({
            modalOpenGrid: !this.state.modalOpenGrid,
            message: storeProxyjson,
            loading: false,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    }
  };

  componentDidMount() {
    let future = this.state.user;

    let pageAllow = false;

    future.map((val, index) =>
      val.value == 1
        ? val.featureAccess
          ? val.featureAccess.map((child1, ind) =>
              child1.value == 1
                ? child1.featureName == 'City Leader Dashboard'
                  ? (pageAllow = true)
                  : ''
                : ''
            )
          : ''
        : ''
    );
    this.handleSearch();
    if (pageAllow) {
      this.setState({
        pageAllowed: true,
        loading: true,
      });
      // ReactTooltip.rebuild();
    } else {
      this.setState({
        pageAllowed: false,
        loading: true,
      });
    }
  }

  render() {
    const {
      loading,
      currentMonth,
      years,
      month,
      currentyear,
      pUType,
      modalOpen,
      cities,
      pageAllowed,
      currentCity,
      cityChanged,
      navigate1,
      activeTab,
      modalOpenGrid,
      storSearch,
      stores,
    } = this.state;
    let future = this.state.user;

    let pageAllow = false;
    let cityDashBoardRetail = [];
    let ma = [];

    if (this.state.currentMonth.length > 1) {
      ma = this.state.currentMonth.split(',');
    }

    if (this.state.proxyjson1) {
      cityDashBoardRetail = this.state.proxyjson1.map((insert) => {
        return (
          <tr
            key={this.state.activeTab > 1 ? insert.storeId : insert.monthNumber}
          >
            <td>
              {this.state.activeTab > 1 ? (
               
                <Link to="/storeDashboardRetail" state={{ 
                  tabIndex: this.props.tabIndex,
                        storeName: insert.storeName,
                        storeId: insert.storeId,
                        currentCity: this.state.currentCity,
                        month:
                          this.state.currentMonth.length > 1
                            ? ma.slice(-1)[0]
                            : this.state.currentMonth,
                        year: this.state.currentyear,
                 }} >
                  {' '}
                  {insert.storeName}
                </Link>
              ) : (
                insert.monthName
              )}
            </td>
            <td
              className={
                insert.storeValue === 'High'
                  ? 'redColorString'
                  : insert.storeValue === 'Low'
                  ? 'greenColorString'
                  : 'orangeColorString'
              }
              style={{ textAlign: 'left' }}
            >
              {insert.storeValue}
            </td>
            <td
              style={{
                textAlign: 'center',
                cursor: insert.ncCount === 0 ? null : 'pointer',
              }}
              onClick={
                insert.ncCount === 0
                  ? null
                  : () => this.handleOnClick(insert, '')
              }
            >
              {insert.ncCount}
            </td>
            <td
              className={
                insert.hcNcCount > '10'
                  ? 'redColorString'
                  : insert.hcNcCount < '05'
                  ? 'greenColorString'
                  : 'orangeColorString'
              }
              style={{
                textAlign: 'center',
                cursor: insert.hcNcCount === 0 ? null : 'pointer',
              }}
              onClick={
                insert.hcNcCount === 0
                  ? null
                  : () => this.handleOnClick(insert, 'High')
              }
            >
              {insert.hcNcCount}
            </td>
            <td
              className={
                insert.sodScore < '80'
                  ? 'redColorString'
                  : insert.sodScore > '90'
                  ? 'greenColorString'
                  : 'orangeColorString'
              }
              style={{
                textAlign: 'center',
                cursor: insert.sodScore === 0 ? null : 'pointer',
              }}
              onClick={
                insert.sodScore === 0
                  ? null
                  : () => this.handleOnClick(insert, 'SOD')
              }
            >
              {insert.sodScore}
            </td>
            <td
              className={
                insert.flowsScore < '70'
                  ? 'redColorString'
                  : insert.flowsScore > '85'
                  ? 'greenColorString'
                  : 'orangeColorString'
              }
              style={{
                textAlign: 'center',
                cursor: insert.flowsScore === 0 ? null : 'pointer',
              }}
              onClick={
                insert.flowsScore === 0
                  ? null
                  : () => this.handleOnClick(insert, 'Flows')
              }
            >
              {insert.flowsScore}
            </td>
            <td
              className={
                insert.bsuScore < '80'
                  ? 'redColorString'
                  : insert.bsuScore > '90'
                  ? 'greenColorString'
                  : 'orangeColorString'
              }
              style={{
                textAlign: 'center',
                cursor: insert.bsuScore === 0 ? null : 'pointer',
              }}
              onClick={
                insert.bsuScore === 0
                  ? null
                  : () => this.handleOnClick(insert, 'BSU')
              }
            >
              {insert.bsuScore}
            </td>
            <td style={{ textAlign: 'center' }}>{insert.weeklyHo}</td>
            <td style={{ textAlign: 'center' }}>{insert.dailyHo}</td>
            <td
              style={{
                textAlign: 'center',
                cursor: insert.incidentCount === 0 ? null : 'pointer',
              }}
              onClick={
                insert.incidentCount === 0
                  ? null
                  : () => this.handleOnClick(insert, 'All')
              }
            >
              {insert.incidentCount}
            </td>
            <td
              className={
                insert.openIncidents > '03'
                  ? 'redColorString '
                  : insert.openIncidents <= '01'
                  ? 'greenColorString'
                  : 'orangeColorString'
              }
              style={{
                textAlign: 'center',
                cursor: insert.openIncidents === 0 ? null : 'pointer',
              }}
              onClick={
                insert.openIncidents === 0
                  ? null
                  : () => this.handleOnClick(insert, 'Open')
              }
            >
              {insert.openIncidents}
            </td>
          </tr>
        );
      });
    } else {
      cityDashBoardRetail.push(
        <tr>
          <td colSpan={11} className='text-center'>
            No Data Available
          </td>
        </tr>
      );
    }
    return (
      <>
        {future.map((val, index) =>
          val.value == 1
            ? val.featureAccess
              ? val.featureAccess.map((child1, ind) =>
                  child1.value == 1
                    ? child1.featureName == 'City Leader Dashboard'
                      ? (pageAllow = true)
                      : ''
                    : ''
                )
              : ''
            : ''
        )}
        {pageAllow === false ? (
        
          <Navigate to="/pageNotAllowed" state={{ id:'City Leader Dashboard' }} />
        ) : (
          ''
        )}
        <Helmet>
          {' '}
          <title>{this.state.title}</title>{' '}
        </Helmet>

        {modalOpen ? (
          <MessageBox
            message={this.state.message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}

        <div className='wrapper'>
          <Header title={this.state.title} />
          <Menu />

          <div className='content-wrapper'>
            <section className='content'>
              <div className='col-md-4'>
                <div className='row'>
                  <div
                    className='col-md-6'
                    style={{ zIndex: '35', marginLeft: '-15px' }}
                  >
                    <MultiMonths
                      options={JSON.stringify(month)}
                      selectFor='month'
                      handleMonthChange={this.handleMonthChange}
                    />
                  </div>
                  <div className='col-md-6'>
                    <form style={{ background: 'none', padding: 'none' }}>
                      <div className='form-group'>
                        <select
                          className='form-control'
                          value={currentyear}
                          onChange={this.handleYearChange}
                          style={{ width: '115%', marginTop: '-5px' }}
                        >
                          <option>Year</option>
                          {years.map((year, yearValue) => (
                            <option key={yearValue} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div className='col-md-4'>
                <div className='row'>
                  <div className='col-md-6'>
                    <MultiCities
                      options={cities}
                      selectFor='cities'
                      handleCityChange={this.handleCityChange}
                    />
                  </div>
                  <div className='col-md-6'>
                    <Multi
                      name='cityDash'
                      storSearch={storSearch}
                      stores={stores}
                      cityChanged={cityChanged}
                      navigate1={navigate1}
                      storesData={this.state.storesData}
                      searchValue={this.state.searchValue}
                    />
                  </div>
                </div>
              </div>

              <div className='col-md-1'>
                <div>
                  <button
                    type='submit'
                    onClick={this.handleSearch}
                    className='deca-btn-yellow'
                  >
                    {'Search'}
                  </button>
                </div>
              </div>

              {loading ? (
                <Spinner />
              ) : (
                <div className='row'>
                  <div className='col-md-12 col-sm-12 exportButton'>
                   
                    <Link to="/PdfExportCityLeader" state={{ 
                       state: this.state,
                 }} >
                      <button
                        className='deca-btn-yellow'
                        style={{ marginBottom: '10px', marginTop: '35px' }}
                      >
                        Download Report
                      </button>
                    </Link>
                  </div>
                  <div className='col-md-12'>
                    {modalOpenGrid ? (
                      <DataPopUp
                        headers={this.state.proxyjson.popUpDataGridHeaders}
                        message={this.state.message}
                        onClose={this.handleClose}
                        loading={this.setLoading}
                        pageLoad={this.state.pageLoad}
                        pUType={pUType}
                      />
                    ) : (
                      ''
                    )}
                    {/* Custom Tabs */}
                    <div className='nav-tabs-custom'>
                      <div className='tab-content'>
                        {this.state.activeTab > 1 ? (
                          <div>
                            <div className='row'>
                              <div className='col-md-12'>
                                <h3
                                  style={{
                                    textDecoration: 'underline',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  <span
                                    style={{
                                      display: 'inline-block',
                                      borderBottom: '2px solid black',
                                      paddingBottom: '4px',
                                    }}
                                  >
                                    City Status
                                  </span>
                                </h3>
                                <div style={{ display: 'flex' }}>
                                  <CityDasboardLegend />
                                </div>

                                <br />
                                <div className='col-md-8 col-sm-8'>
                                  <table
                                    className='table table-bordered table-hover table-striped lastRow'
                                    style={{
                                      borderCollapse: 'collapse',
                                    }}
                                  >
                                    <thead
                                      className='text-left'
                                      style={{
                                        backgroundColor: '#3c8dbc',
                                        color: '#fff',
                                      }}
                                    >
                                      <tr>
                                        <th style={{ textAlign: 'center' }}>
                                          Store Name
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          Risk Level
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          Open non-confirmities
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          High Priority
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          SOD
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          Monthly Flows
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          BSU
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          Weekly H/O
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          Daily H/O
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          No.of Incidents
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          Open Incidents
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className='mms text-left'>
                                      {cityDashBoardRetail}
                                    </tbody>
                                  </table>
                                </div>
                                <div className='col-md-4 col-sm-4 col-xs-4'>
                                  <PopUpData someData={'storeData'} />
                                </div>
                              </div>
                            </div>
                            <br />

                            <br />
                            <br />
                            <div className='row'>
                              <div className='col-md-12'>
                                <h3
                                  style={{
                                    textDecoration: 'underline',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  <span
                                    style={{
                                      display: 'inline-block',
                                      borderBottom: '2px solid black',
                                      paddingBottom: '4px',
                                    }}
                                  >
                                    Store Training Status
                                  </span>
                                </h3>

                                <div style={{ display: 'flex' }}>
                                  <CityDasboardLegend />
                                </div>
                                <div className='col-md-8 inlineTable'>
                                  <DataTables
                                    type='retail'
                                    title='Evacuations'
                                    storeDashboard={true}
                                    tabIndex={activeTab}
                                    data={this.state.proxyjson5}
                                    currentCity={currentCity}
                                    name='Evacuations'
                                    storeid=''
                                    year={currentyear}
                                    month={currentMonth}
                                  />
                                </div>
                                <div className='col-md-4'>
                                  <br />
                                  <PopUpData1 someData={'trainingData'} />
                                </div>
                              </div>
                            </div>
                            <br />

                            <br />
                          </div>
                        ) : this.state.activeTab < 2 ? (
                          <div>
                            <div className='row'>
                              <div className='col-md-12'>
                                <h3
                                  style={{
                                    textDecoration: 'underline',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  <span
                                    style={{
                                      display: 'inline-block',
                                      borderBottom: '2px solid black',
                                      paddingBottom: '4px',
                                    }}
                                  >
                                    City Status
                                  </span>
                                </h3>
                                <div style={{ display: 'flex' }}>
                                  <CityDasboardLegend />
                                </div>

                                <br />
                                <div className='col-md-8 inlineTable'>
                                  <table
                                    className='table table-bordered lastRow table-hover table-striped '
                                    style={{
                                      borderCollapse: 'collapse',
                                    }}
                                  >
                                    <thead
                                      className=''
                                      style={{
                                        backgroundColor: '#3c8dbc',
                                        color: '#fff',
                                      }}
                                    >
                                      <tr style={{ textAlign: 'center' }}>
                                        <th style={{ textAlign: 'center' }}>
                                          Month Name
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          Risk Level
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          Open non-confirmities
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          High Priority
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          SOD
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          Monthly Flows
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          BSU
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          Weekly H/O
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          Daily H/O
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          No.of Incidents
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                          Open Incidents
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className='mms text-center'>
                                      {cityDashBoardRetail}
                                    </tbody>
                                  </table>
                                </div>
                                <div className='col-md-4'>
                                  <PopUpData someData={'storeData'} />
                                </div>
                              </div>
                            </div>
                            <br />

                            <div className='row'>
                              <div className='col-md-12'>
                                <h3
                                  style={{
                                    textDecoration: 'underline',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  <span
                                    style={{
                                      display: 'inline-block',
                                      borderBottom: '2px solid black',
                                      paddingBottom: '4px',
                                    }}
                                  >
                                    Store Training Status
                                  </span>
                                </h3>

                                <div style={{ display: 'flex' }}>
                                  <CityDasboardLegend />
                                </div>

                                <div className='col-md-8 inlineTable'>
                                  <DataTables
                                    storeDashboard={true}
                                    data={this.state.proxyjson4}
                                    storeid={this.state.storeIdNo}
                                    year={currentyear}
                                    month={currentMonth}
                                  />
                                </div>
                                <div className='col-md-4'>
                                  <br />
                                  <PopUpData1 someData={'trainingData'} />
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </section>
          </div>

          <Footer />
        </div>
      </>
    );
  }
}

export default Cityleader;
